import { FC, PropsWithChildren } from 'react'
import { cx } from '../styles/stylebook'

interface FlexGridLayoutProps extends PropsWithChildren {
  cols?: number
  className?: string
  gap?: string
  noPadding?: boolean
}

interface FlexGridItemProps extends PropsWithChildren {
  cols?: number
  flex?: boolean
  className?: string
}

const FlexGridLayout: FC<FlexGridLayoutProps> = ({
  children,
  cols = 12,
  className = '',
  gap = '',
  noPadding = false,
}) => {
  return (
    <div
      className={cx(
        'flex w-full',
        noPadding ? '' : 'px-marg',
        gap ? `gap-${gap}` : 'gap-[var(--spacing-gutter)]',
        className
      )}
      data-total-cols={cols}
    >
      {children}
    </div>
  )
}

export const FlexGridItem: FC<FlexGridItemProps> = ({
  children,
  cols = 1,
  flex = false,
  className = '',
}) => {
  // 부모 컴포넌트에서 총 컬럼 수를 가져와야 하지만,
  // 일단 기본값 12로 설정하고 CSS 변수를 활용
  const getTotalCols = () => 12 // 나중에 Context나 다른 방법으로 개선

  const getWidth = () => {
    if (flex) return undefined

    // size 변수를 사용한 간단한 매핑
    switch (cols) {
      case 1:
        return 'grid-1'
      case 2:
        return 'grid-2'
      case 3:
        return 'grid-3'
      case 4:
        return 'grid-4'
      case 6:
        return 'grid-6'
      case 8:
        return 'grid-8'
      case 9:
        return 'grid-9'
      case 10:
        return 'grid-10'
      case 12:
        return 'grid-12'
      default:
        return 'grid-1'
    }
  }

  const itemStyle: React.CSSProperties = {
    ...(flex && { flex: 1 }),
  }

  return (
    <div className={cx(className, `w-${getWidth()}`)} style={itemStyle}>
      {children}
    </div>
  )
}

export default FlexGridLayout
